export const initialStyleOptions = {
    primaryFont: `'Open Sans','Arial','Calibri','Helvetica Neue','sans-serif'`,
    loadingColor: '#FF4422'
};
//# sourceMappingURL=StyleOptions.js.map